import { render, staticRenderFns } from "./match-sign-up.vue?vue&type=template&id=721e74b3&scoped=true"
import script from "./match-sign-up.vue?vue&type=script&lang=js"
export * from "./match-sign-up.vue?vue&type=script&lang=js"
import style0 from "./match-sign-up.vue?vue&type=style&index=0&id=721e74b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721e74b3",
  null
  
)

export default component.exports